import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/dow.svg'
import _imports_1 from '@/assets/free.png'


const _withScopeId = n => (_pushScopeId("data-v-02e5eb68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download d-flex flex-column justify-content-center flex-md-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "download-para" }, [
  /*#__PURE__*/_createTextVNode(" You don’t know "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" where to start from? ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download-svg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "dowl"
  })
], -1))
const _hoisted_4 = { class: "download-end d-flex flex-column" }
const _hoisted_5 = { class: "download-scaling" }
const _hoisted_6 = ["xlink:href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Download Halal App", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download-end-img align-self-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-100 h-100",
    alt: "free"
  })
], -1))
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center gap-5" }
const _hoisted_10 = {
  href: "https://play.google.com/store/apps/details?id=com.withhalal.withhalalmobile",
  icon: "facebook",
  target: "_blank",
  title: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("use", {
          "xlink:href": `${require('@/assets/icons.svg')}#icon-star`
        }, null, 8, _hoisted_6)
      ])),
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadsgoogle, (download) => {
            return (_openBlock(), _createBlock(_component_Button, {
              key: download.head,
              iconed: "",
              icon: download.icon,
              head: download.head,
              foot: download.foot
            }, null, 8, ["icon", "head", "foot"]))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadsapple, (download) => {
          return (_openBlock(), _createBlock(_component_Button, {
            key: download.head,
            iconed: "",
            icon: download.icon,
            head: download.head,
            foot: download.foot,
            onClick: _ctx.countdown
          }, null, 8, ["icon", "head", "foot", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}